import React from 'react';
import { Link } from 'react-router-dom';

export default function NavbarPanelItem({ route, src, text, minitext }) {

 
  return (
    <>

          <Link className='link navbarList' to={route}>
            <img className='navbarIconN' src={src} />
            <p className='minitextnavbar' > {text} </p>
            <p className='minitextside'> {minitext} </p>
          </Link>
        </>



  )
}
